import { TIERS } from "constants/pricing";

export const LEARN_MORE_VIDEOS_BY_TIER = {
  [TIERS.STANDARD]: "AJZPfiy4MvQ",
  [TIERS.PRO]: "EktHUKbOjVU"
};

export const hasLearnMoreVideo = function (tier) {
  const learnMoreVideoTiers = Object.keys(LEARN_MORE_VIDEOS_BY_TIER)
  return learnMoreVideoTiers.includes(tier);
};
